module.exports = __webpack_public_path__ + "img/bg_register_volunteer.18322e93.png";